module.exports = __webpack_public_path__ + "img/MEDIA017.14974bcb.jpg";